<template>
  <div class="concentrator-list" v-loading="loading">
    <div class="head_body">
      <el-form ref="form" :model="filter" class="search_head">
        <el-row :gutter="20" class="list-head">
          <el-col :span="4">
            <el-form-item :label="$t('device.device_number')">
              <el-input v-model="filter.number" :placeholder="$t('device.please_device_number')" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('device.device_name')">
              <el-input v-model="filter.name" :placeholder="$t('device.please_device_name')" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('device.state')">
              <el-select
                clearable
                :placeholder="$t('device.state')"
                v-model="filter.ste"
                style="width: 100%"
              >
              <el-option key="all" :label="$t('control.all')" value=""></el-option>
                <el-option
                  v-for="(t,index) in steList"
                  :key="index"
                  :label="t"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="2" class="search-btn-box">
              <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>{{$t('control.search')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h_line"></div>
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            >{{$t('control.add')}}</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="ID" width="100"> </el-table-column>
        <el-table-column prop="name" :label="$t('control.name')"> </el-table-column>
        <el-table-column prop="number" :label="$t('control.number')"> </el-table-column>
        <el-table-column prop="stg_name" :label="$t('control.strategy')"> </el-table-column>
        <el-table-column prop="type" :label="$t('control.model')">
          <template slot-scope="scope">
            {{typeArr[scope.row.type]}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('control.lng_lat')">
          <template slot-scope="scope">
            {{ scope.row.longitude }},{{ scope.row.latitude }}
          </template>
        </el-table-column>
        <el-table-column prop="type" :label="$t('concentrator.loop_control')">
          <template slot-scope="scope">
            <el-button type="primary" @click="openLampLoop(scope.row)" round>{{$t('concentrator.loop_control')}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('device.state')"
          prop="ste"
          width="140"
          align="center"
          v-if="pageInfo.lamp_protocol!='2'"
          sortable
        >
          <template slot-scope="scope">
            <i :class="steColorType[scope.row.ste]"></i>
            <span>{{ steList[scope.row.ste] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="edit" :label="$t('control.operate')" width="100">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>

    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? $t('control.add') : $t('control.edit')"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        :rules="editOneRule"
        :label-width="$i18n.locale==='zh-CN'?'100px':'140px'"
      >
        <div class="form-info">
          <el-form-item :label="$t('control.name')" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('control.number')" prop="number">
            <el-input v-model="editOne.number"></el-input>
          </el-form-item>
          <el-form-item :label="$t('concentrator.current_ratio')" prop="ct">
            <el-input v-model="editOne.ct"></el-input>
          </el-form-item>
          <el-form-item :label="$t('control.model')" prop="type">
            <el-radio-group v-model="editOne.type">
              <el-radio :label="1">FRD-CC-01</el-radio>
              <el-radio :label="2">FRD-CC-02</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="editOne.type==2" :label="$t('concentrator.mail_address')" prop="mail_address">
            <el-input v-model="editOne.mail_address"></el-input>
          </el-form-item>
          <div class="map-container">
            <el-amap
              ref="map"
              vid="amap"
              :center="myMap.center"
              :zoom="myMap.zoom"
              :plugin="myMap.plugin"
              class="amap-demo"
              mapStyle="amap://styles/light"
              :events="myMap.events"
            >
              <el-amap-circle-marker
                :center="myMap.markercenter"
                :radius="myMap.radius"
                fillColor="gray"
                strokeColor="#fff"
                :fillOpacity="myMap.fillOpacity"
              >
              </el-amap-circle-marker>
            </el-amap>
          </div>
          <div class="h10"></div>
          <el-form-item :label="$t('control.longitude')" prop="longitude">
            <el-input v-model="editOne.longitude"></el-input>
          </el-form-item>
          <el-form-item :label="$t('control.latitude')" prop="latitude">
            <el-input v-model="editOne.latitude"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >{{$t('control.confirm')}}</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>

    <!--回路控制-->
    <el-dialog
      v-if="lampLoop.dialogVisible"
      :visible.sync="lampLoop.dialogVisible"
      class="dialog800"
      :title="'['+lampLoop.name +']'+$t('concentrator.loop_control')"
    >
      <concentrator-loop
        ref="lampLoop"
        :id="lampLoop.id"
        @closeMethod="closeLampLoop"
      ></concentrator-loop>
    </el-dialog>
  </div>
</template>

<script>
import concentratorApi from "@/api/concentrator/list";
import concentratorLoop from "@/components/device/concentratorLoop";
import commonJs from '@/utils/common'
import store from '@/store'
export default {
  components: {
    concentratorLoop
  },
  data() {
    const vm = this;
    return {
      myMap: {
        center: store.state.user.account_map.center,
        markercenter: store.state.user.account_map.center,
        events: {
          mapmove: () => {
            this.handleMove();
          },
        },
        zoom: 18,
        radius: 10,
        fillOpacity: 1,
      },
      loading: false,
      dialogVisible: false,
      typeArr: ['','FRD-CC-01','FRD-CC-02'],
      steColorType: ["valuegrey", "valuegreen"],
      steList: this.$t('device.steList'),
      tableData: [],
      pageInfo: {
        filter: '',
        page: 1,
        pageSize: 20
      },
      filter: {
        number: '',
        name: '',
        ste: '' // 0离线、1在线
      },
      cnt_all: 0,
      editOneRule: {
        name: [{ required: true, message: this.$t('device.please_name'), trigger: "blur" }],
      },
      editType: -1,
      devSelect: [],
      editOne: {
        name: '',
        number: '',
        mail_address: '',
        ct: '',
        type: 1,
        longitude: '',
        latitude: ''
      },
      lampLoop: {
        id: null,
        dialogVisible: false,
        name: ''
      }
    };
  },
  methods: {
    // 获取列表
    getTableData(pageIndex) {
      this.pageInfo.filter = ''
      this.loading = true;
      this.pageInfo.page = pageIndex;
      let filter = this.filter;
      filter = filter && commonJs.obj.removeNullKey(filter);
      if (filter && Object.keys(filter).length) {
        this.pageInfo.filter = JSON.stringify(filter);
      }
      concentratorApi.concentratorList(this.pageInfo).then((res) => {
        
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list; 
          this.pageInfo.page = pageIndex;   
          this.cnt_all = parseInt(resData.count);
        }
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          name: '',
          number: '',
          mail_address: '',
          ct: '',
          type: 1,
          longitude: '',
          latitude: ''
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          name: index.name,
          number: index.number,
          mail_address: index.mail_address,
          ct: index.ct,
          type: index.type,
          longitude:index.longitude,
          latitude:index.latitude,
        };

        let lng = index.longitude
        let lat = index.latitude
        let lngLat = [lng, lat]
        if(!lng){
          lngLat = store.state.user.account_map.center
        }
        
        this.myMap.center = lngLat
        this.myMap.markercenter = lngLat

        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      concentratorApi.concentratorEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.mod_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      concentratorApi.concentratorAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.add_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm(this.$t('control.tip_del_data_title'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          concentratorApi.concentratorDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.del_success'));
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del'),
          });
        });
    },
    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.getTableData(1)
    },
    handleMove() {
      this.myMap.markercenter = this.$refs.map.$$getCenter();
      this.editOne.longitude = this.myMap.markercenter[0];
      this.editOne.latitude = this.myMap.markercenter[1];
    },
    // 回路控制
    openLampLoop(row) {
      this.lampLoop = {
        id: row.id,
        dialogVisible: true,
        name: row.name
      }
    },
    closeLampLoop() {
      this.lampLoop = {
        id: null,
        dialogVisible: false,
        name: ''
      }
    },
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  }
};
</script>
<style lang='less'>
.concentrator-list {
  width: 100%;
  .map-container {
    padding-left: 100px;
    height: 180px;
    margin-bottom: 10px;
  }
  .form-info{
    padding: 8px;
    .el-form-item{
      display: flex;
      .el-form-item__label{
        width:100px;
      }
      .el-form-item__content{
        flex: 1;
      }
    }
    
  }
}

</style>